function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["ariaLabel", "menuClassName", "menuStyle", "arrow", "arrowProps", "anchorPoint", "anchorRef", "containerRef", "containerProps", "focusProps", "externalRef", "parentScrollingRef", "align", "direction", "position", "overflow", "setDownOverflow", "repositionFlag", "captureFocus", "state", "endTransition", "isDisabled", "menuItemFocus", "gap", "shift", "children", "onClose"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useState, useReducer, useContext, useRef, useCallback, useEffect, useMemo } from 'react';
import { flushSync } from 'react-dom';
import { MenuContainer } from './MenuContainer.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { createSubmenuCtx } from '../utils/submenuCtx.js';
import { SettingsContext, MenuListContext, HoverActionTypes, menuClass, menuArrowClass, positionAbsolute, dummyItemProps, MenuListItemContext, HoverItemContext, Keys, CloseReason, FocusPositions } from '../utils/constants.js';
import { useItems } from '../hooks/useItems.js';
import { getScrollAncestor, floatEqual, commonProps, mergeProps, safeCall, isMenuOpen, getTransition, batchedUpdates } from '../utils/utils.js';
import { getPositionHelpers } from '../positionUtils/getPositionHelpers.js';
import { positionMenu } from '../positionUtils/positionMenu.js';
import { useLayoutEffect as useIsomorphicLayoutEffect } from '../hooks/useIsomorphicLayoutEffect.js';
import { useBEM } from '../hooks/useBEM.js';
import { useCombinedRef } from '../hooks/useCombinedRef.js';
var offScreen = -9999;
var MenuList = function MenuList(_ref) {
  var ariaLabel = _ref.ariaLabel,
    menuClassName = _ref.menuClassName,
    menuStyle = _ref.menuStyle,
    arrow = _ref.arrow,
    _ref$arrowProps = _ref.arrowProps,
    arrowProps = _ref$arrowProps === void 0 ? {} : _ref$arrowProps,
    anchorPoint = _ref.anchorPoint,
    anchorRef = _ref.anchorRef,
    containerRef = _ref.containerRef,
    containerProps = _ref.containerProps,
    focusProps = _ref.focusProps,
    externalRef = _ref.externalRef,
    parentScrollingRef = _ref.parentScrollingRef,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'bottom' : _ref$direction,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'auto' : _ref$position,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? 'visible' : _ref$overflow,
    setDownOverflow = _ref.setDownOverflow,
    repositionFlag = _ref.repositionFlag,
    _ref$captureFocus = _ref.captureFocus,
    captureFocus = _ref$captureFocus === void 0 ? true : _ref$captureFocus,
    state = _ref.state,
    endTransition = _ref.endTransition,
    isDisabled = _ref.isDisabled,
    menuItemFocus = _ref.menuItemFocus,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 0 : _ref$gap,
    _ref$shift = _ref.shift,
    shift = _ref$shift === void 0 ? 0 : _ref$shift,
    children = _ref.children,
    onClose = _ref.onClose,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({
      x: offScreen,
      y: offScreen
    }),
    _useState2 = _slicedToArray(_useState, 2),
    menuPosition = _useState2[0],
    setMenuPosition = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    arrowPosition = _useState4[0],
    setArrowPosition = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    overflowData = _useState6[0],
    setOverflowData = _useState6[1];
  var _useState7 = useState(direction),
    _useState8 = _slicedToArray(_useState7, 2),
    expandedDirection = _useState8[0],
    setExpandedDirection = _useState8[1];
  var _useState9 = useState(createSubmenuCtx),
    _useState10 = _slicedToArray(_useState9, 1),
    submenuCtx = _useState10[0];
  var _useReducer = useReducer(function (c) {
      return c + 1;
    }, 1),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    reposSubmenu = _useReducer2[0],
    forceReposSubmenu = _useReducer2[1];
  var _useContext = useContext(SettingsContext),
    transition = _useContext.transition,
    boundingBoxRef = _useContext.boundingBoxRef,
    boundingBoxPadding = _useContext.boundingBoxPadding,
    rootMenuRef = _useContext.rootMenuRef,
    rootAnchorRef = _useContext.rootAnchorRef,
    scrollNodesRef = _useContext.scrollNodesRef,
    reposition = _useContext.reposition,
    viewScroll = _useContext.viewScroll,
    submenuCloseDelay = _useContext.submenuCloseDelay;
  var _useContext2 = useContext(MenuListContext),
    parentSubmenuCtx = _useContext2.submenuCtx,
    _useContext2$reposSub = _useContext2.reposSubmenu,
    reposFlag = _useContext2$reposSub === void 0 ? repositionFlag : _useContext2$reposSub;
  var menuRef = useRef(null);
  var focusRef = useRef();
  var arrowRef = useRef();
  var prevOpen = useRef(false);
  var latestMenuSize = useRef({
    width: 0,
    height: 0
  });
  var latestHandlePosition = useRef(function () {});
  var _useItems = useItems(menuRef, focusRef),
    hoverItem = _useItems.hoverItem,
    dispatch = _useItems.dispatch,
    updateItems = _useItems.updateItems;
  var isOpen = isMenuOpen(state);
  var openTransition = getTransition(transition, 'open');
  var closeTransition = getTransition(transition, 'close');
  var scrollNodes = scrollNodesRef.current;
  var onKeyDown = function onKeyDown(e) {
    switch (e.key) {
      case Keys.HOME:
        dispatch(HoverActionTypes.FIRST);
        break;
      case Keys.END:
        dispatch(HoverActionTypes.LAST);
        break;
      case Keys.UP:
        dispatch(HoverActionTypes.DECREASE, hoverItem);
        break;
      case Keys.DOWN:
        dispatch(HoverActionTypes.INCREASE, hoverItem);
        break;
      case Keys.SPACE:
        if (e.target && e.target.className.indexOf(menuClass) !== -1) {
          e.preventDefault();
        }
        return;
      default:
        return;
    }
    e.preventDefault();
    e.stopPropagation();
  };
  var onAnimationEnd = function onAnimationEnd() {
    if (state === 'closing') {
      setOverflowData();
    }
    safeCall(endTransition);
  };
  var onPointerMove = function onPointerMove(e) {
    e.stopPropagation();
    submenuCtx.on(submenuCloseDelay, function () {
      dispatch(HoverActionTypes.RESET);
      focusRef.current.focus();
    });
  };
  var onPointerLeave = function onPointerLeave(e) {
    if (e.target === e.currentTarget) submenuCtx.off();
  };
  var handlePosition = useCallback(function (noOverflowCheck) {
    var _anchorRef$current;
    var anchorRect = anchorRef ? (_anchorRef$current = anchorRef.current) == null ? void 0 : _anchorRef$current.getBoundingClientRect() : anchorPoint ? {
      left: anchorPoint.x,
      right: anchorPoint.x,
      top: anchorPoint.y,
      bottom: anchorPoint.y,
      width: 0,
      height: 0
    } : null;
    if (!anchorRect) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[React-Menu] Menu might not be positioned properly as one of the anchorRef or anchorPoint prop should be provided. If `anchorRef` is provided, the anchor must be mounted before menu is open.');
      }
      return;
    }
    if (!scrollNodes.menu) {
      scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : getScrollAncestor(rootMenuRef.current)) || window;
    }
    var positionHelpers = getPositionHelpers(containerRef, menuRef, scrollNodes.menu, boundingBoxPadding);
    var _positionMenu = positionMenu({
        arrow: arrow,
        align: align,
        direction: direction,
        gap: gap,
        shift: shift,
        position: position,
        anchorRect: anchorRect,
        arrowRef: arrowRef,
        positionHelpers: positionHelpers
      }),
      arrowX = _positionMenu.arrowX,
      arrowY = _positionMenu.arrowY,
      x = _positionMenu.x,
      y = _positionMenu.y,
      computedDirection = _positionMenu.computedDirection;
    var menuRect = positionHelpers.menuRect;
    var menuHeight = menuRect.height;
    if (!noOverflowCheck && overflow !== 'visible') {
      var getTopOverflow = positionHelpers.getTopOverflow,
        getBottomOverflow = positionHelpers.getBottomOverflow;
      var height, _overflowAmt;
      var prevHeight = latestMenuSize.current.height;
      var bottomOverflow = getBottomOverflow(y);
      if (bottomOverflow > 0 || floatEqual(bottomOverflow, 0) && floatEqual(menuHeight, prevHeight)) {
        height = menuHeight - bottomOverflow;
        _overflowAmt = bottomOverflow;
      } else {
        var topOverflow = getTopOverflow(y);
        if (topOverflow < 0 || floatEqual(topOverflow, 0) && floatEqual(menuHeight, prevHeight)) {
          height = menuHeight + topOverflow;
          _overflowAmt = 0 - topOverflow;
          if (height >= 0) y -= topOverflow;
        }
      }
      if (height >= 0) {
        menuHeight = height;
        setOverflowData({
          height: height,
          overflowAmt: _overflowAmt
        });
      } else {
        setOverflowData();
      }
    }
    if (arrow) setArrowPosition({
      x: arrowX,
      y: arrowY
    });
    setMenuPosition({
      x: x,
      y: y
    });
    setExpandedDirection(computedDirection);
    latestMenuSize.current = {
      width: menuRect.width,
      height: menuHeight
    };
  }, [arrow, align, boundingBoxPadding, direction, gap, shift, position, overflow, anchorPoint, anchorRef, containerRef, boundingBoxRef, rootMenuRef, scrollNodes]);
  useIsomorphicLayoutEffect(function () {
    if (isOpen) {
      handlePosition();
      if (prevOpen.current) forceReposSubmenu();
    }
    prevOpen.current = isOpen;
    latestHandlePosition.current = handlePosition;
  }, [isOpen, handlePosition, reposFlag]);
  useIsomorphicLayoutEffect(function () {
    if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
  }, [overflowData, setDownOverflow]);
  useIsomorphicLayoutEffect(function () {
    return updateItems;
  }, [updateItems]);
  useEffect(function () {
    var menuScroll = scrollNodes.menu;
    if (!isOpen || !menuScroll) return;
    menuScroll = menuScroll.addEventListener ? menuScroll : window;
    if (!scrollNodes.anchors) {
      scrollNodes.anchors = [];
      var anchorScroll = getScrollAncestor(rootAnchorRef && rootAnchorRef.current);
      while (anchorScroll && anchorScroll !== menuScroll) {
        scrollNodes.anchors.push(anchorScroll);
        anchorScroll = getScrollAncestor(anchorScroll);
      }
    }
    var scroll = viewScroll;
    if (scrollNodes.anchors.length && scroll === 'initial') scroll = 'auto';
    if (scroll === 'initial') return;
    var handleScroll = function handleScroll() {
      if (scroll === 'auto') {
        batchedUpdates(function () {
          return handlePosition(true);
        });
      } else {
        safeCall(onClose, {
          reason: CloseReason.SCROLL
        });
      }
    };
    var scrollObservers = scrollNodes.anchors.concat(viewScroll !== 'initial' ? menuScroll : []);
    scrollObservers.forEach(function (o) {
      return o.addEventListener('scroll', handleScroll);
    });
    return function () {
      return scrollObservers.forEach(function (o) {
        return o.removeEventListener('scroll', handleScroll);
      });
    };
  }, [rootAnchorRef, scrollNodes, isOpen, onClose, viewScroll, handlePosition]);
  var hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
  useEffect(function () {
    if (hasOverflow || !isOpen || !parentScrollingRef) return;
    var handleScroll = function handleScroll() {
      return batchedUpdates(handlePosition);
    };
    var parentScroll = parentScrollingRef.current;
    parentScroll.addEventListener('scroll', handleScroll);
    return function () {
      return parentScroll.removeEventListener('scroll', handleScroll);
    };
  }, [isOpen, hasOverflow, parentScrollingRef, handlePosition]);
  useEffect(function () {
    if (typeof ResizeObserver !== 'function' || reposition === 'initial') return;
    var resizeObserver = new ResizeObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        entry = _ref3[0];
      var borderBoxSize = entry.borderBoxSize,
        target = entry.target;
      var width, height;
      if (borderBoxSize) {
        var _ref4 = borderBoxSize[0] || borderBoxSize,
          inlineSize = _ref4.inlineSize,
          blockSize = _ref4.blockSize;
        width = inlineSize;
        height = blockSize;
      } else {
        var borderRect = target.getBoundingClientRect();
        width = borderRect.width;
        height = borderRect.height;
      }
      if (width === 0 || height === 0) return;
      if (floatEqual(width, latestMenuSize.current.width, 1) && floatEqual(height, latestMenuSize.current.height, 1)) return;
      flushSync(function () {
        latestHandlePosition.current();
        forceReposSubmenu();
      });
    });
    var observeTarget = menuRef.current;
    resizeObserver.observe(observeTarget, {
      box: 'border-box'
    });
    return function () {
      return resizeObserver.unobserve(observeTarget);
    };
  }, [reposition]);
  useEffect(function () {
    if (!isOpen) {
      dispatch(HoverActionTypes.RESET);
      if (!closeTransition) setOverflowData();
      return;
    }
    var _ref5 = menuItemFocus || {},
      position = _ref5.position,
      alwaysUpdate = _ref5.alwaysUpdate;
    var setItemFocus = function setItemFocus() {
      if (position === FocusPositions.FIRST) {
        dispatch(HoverActionTypes.FIRST);
      } else if (position === FocusPositions.LAST) {
        dispatch(HoverActionTypes.LAST);
      } else if (position >= -1) {
        dispatch(HoverActionTypes.SET_INDEX, undefined, position);
      }
    };
    if (alwaysUpdate) {
      setItemFocus();
    } else if (captureFocus) {
      var id = setTimeout(function () {
        if (!menuRef.current.contains(document.activeElement)) {
          focusRef.current.focus();
          setItemFocus();
        }
      }, openTransition ? 170 : 100);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [isOpen, openTransition, closeTransition, captureFocus, menuItemFocus, dispatch]);
  var itemContext = useMemo(function () {
    return {
      isParentOpen: isOpen,
      submenuCtx: submenuCtx,
      dispatch: dispatch,
      updateItems: updateItems
    };
  }, [isOpen, submenuCtx, dispatch, updateItems]);
  var maxHeight, overflowAmt;
  if (overflowData) {
    setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
  }
  var listContext = useMemo(function () {
    return {
      reposSubmenu: reposSubmenu,
      submenuCtx: submenuCtx,
      overflow: overflow,
      overflowAmt: overflowAmt,
      parentMenuRef: menuRef,
      parentDir: expandedDirection
    };
  }, [reposSubmenu, submenuCtx, overflow, overflowAmt, expandedDirection]);
  var overflowStyle = maxHeight >= 0 ? {
    maxHeight: maxHeight,
    overflow: overflow
  } : undefined;
  var modifiers = useMemo(function () {
    return {
      state: state,
      dir: expandedDirection
    };
  }, [state, expandedDirection]);
  var arrowModifiers = useMemo(function () {
    return {
      dir: expandedDirection
    };
  }, [expandedDirection]);
  var _arrowClassName = useBEM({
    block: menuClass,
    element: menuArrowClass,
    modifiers: arrowModifiers,
    className: arrowProps.className
  });
  var menu = /*#__PURE__*/jsxs("ul", _objectSpread(_objectSpread(_objectSpread({
    role: "menu",
    "aria-label": ariaLabel
  }, commonProps(isDisabled)), mergeProps({
    onPointerEnter: parentSubmenuCtx == null ? void 0 : parentSubmenuCtx.off,
    onPointerMove: onPointerMove,
    onPointerLeave: onPointerLeave,
    onKeyDown: onKeyDown,
    onAnimationEnd: onAnimationEnd
  }, restProps)), {}, {
    ref: useCombinedRef(externalRef, menuRef),
    className: useBEM({
      block: menuClass,
      modifiers: modifiers,
      className: menuClassName
    }),
    style: _objectSpread(_objectSpread(_objectSpread({}, menuStyle), overflowStyle), {}, {
      margin: 0,
      display: state === 'closed' ? 'none' : undefined,
      position: positionAbsolute,
      left: menuPosition.x,
      top: menuPosition.y
    }),
    children: [/*#__PURE__*/jsx("li", _objectSpread(_objectSpread({
      tabIndex: -1,
      style: {
        position: positionAbsolute,
        left: 0,
        top: 0,
        display: 'block',
        outline: 'none'
      },
      ref: focusRef
    }, dummyItemProps), focusProps)), arrow && /*#__PURE__*/jsx("li", _objectSpread(_objectSpread(_objectSpread({}, dummyItemProps), arrowProps), {}, {
      className: _arrowClassName,
      style: _objectSpread({
        display: 'block',
        position: positionAbsolute,
        left: arrowPosition.x,
        top: arrowPosition.y
      }, arrowProps.style),
      ref: arrowRef
    })), /*#__PURE__*/jsx(MenuListContext.Provider, {
      value: listContext,
      children: /*#__PURE__*/jsx(MenuListItemContext.Provider, {
        value: itemContext,
        children: /*#__PURE__*/jsx(HoverItemContext.Provider, {
          value: hoverItem,
          children: safeCall(children, modifiers)
        })
      })
    })]
  }));
  return containerProps ? /*#__PURE__*/jsx(MenuContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
    isOpen: isOpen,
    children: menu
  })) : menu;
};
export { MenuList };